
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hi/[treatment]",
      function () {
        return require("private-next-pages/hi/[treatment].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hi/[treatment]"])
      });
    }
  